import { normalize } from '@wix/da-shared-react/pkg/redux/normalizr';
import { deviationSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/deviation';
import {
  getAllModulesInitActions,
  getModuleData,
  getSectionModules,
} from './common';
import { withOffset } from '@wix/da-shared-react/pkg/Stream';
import { ALL_FOLDER_ID, SCRAPS_FOLDER_ID } from '@wix/da-url';
import { EmptyCollectionsFolderException } from '../../utils/errorHandling';
import {
  getFolderDeviationsStreamId,
  getFolderDeviationsStreamParams,
  FOLDER_DEVIATIONS_STREAM_GROUP_ID,
  DEVIATIONS_PER_FETCH_COUNT,
} from '../../../client/streams/folderDeviations';
import { DEFAULT_GALLECTION_VIEW_TYPE } from '../../../client/components/Sections/GallectionsSection/consts';
import { GallectionType } from '../../../types/gallection';
import { ModuleType } from '../../../types/modules';
import { getFoldersModuleInitAction } from './modules';
import {
  setSelectedFolderId,
  setSortOrder,
  setViewType,
  setGallectionSectionType,
  setFullViewFolderIds,
  setSelectedSubfolderId,
} from '../../../client/actions/gallectionSection';
import { getDefaultFolderFromFolders } from '../../../client/components/Sections/GallectionsSection/helpers';
import { putScrapsFolderLast } from '../../../client/utils/folders';

export function getFolderDeviationsInitAction(
  gallectionType,
  responseData,
  requestParams
) {
  const moduleData = getModuleData(
    responseData.sectionData.modules,
    ModuleType.FOLDER_DEVIATIONS
  );
  if (!moduleData) {
    return null;
  }

  const { result, entities } = normalize(moduleData.deviations, [
    deviationSchema,
  ]);

  return withOffset.actions.initialize({
    streamId: getFolderDeviationsStreamId(
      gallectionType,
      moduleData.folderId,
      requestParams.mode
    ),
    streamParams: getFolderDeviationsStreamParams(
      gallectionType,
      moduleData.folderId,
      requestParams.mode
    ),
    groupId: FOLDER_DEVIATIONS_STREAM_GROUP_ID,
    itemsPerFetch: DEVIATIONS_PER_FETCH_COUNT,
    nextOffset: moduleData.nextOffset,
    items: result,
    hasMore: !result || !result.length ? false : moduleData.hasMore,
    entities,
  });
}

export function getGallectionsSectionInitActions(
  section: 'gallery' | 'favourites',
  responseData,
  requestParams
) {
  const gallectionType =
    section === 'favourites'
      ? GallectionType.COLLECTION
      : GallectionType.GALLERY;

  const foldersModuleData = getModuleData(
    responseData.sectionData.modules,
    ModuleType.FOLDERS
  );

  let folders = foldersModuleData && foldersModuleData.results;
  if (!folders) {
    return [];
  }
  folders = [...folders].sort(putScrapsFolderLast);

  let initFolderId;
  let initSubfolderId;
  if (requestParams.all_folder) {
    initFolderId = ALL_FOLDER_ID;
  } else if (requestParams.scraps_folder) {
    initFolderId = SCRAPS_FOLDER_ID;
  } else if (requestParams.folder_id) {
    initFolderId = +requestParams.folder_id;
    const initFolder = folders.find(folder => folder.folderId === initFolderId);
    // If the requested folder is a collection (favourites) and is empty we want to return a 404
    if (!initFolder || (initFolder.size < 1 && section === 'favourites')) {
      const username =
        responseData.session.user && responseData.session.user.username;
      throw new EmptyCollectionsFolderException(username);
    } else if (initFolder.parentId) {
      initFolderId = initFolder.parentId;
      initSubfolderId = initFolder.folderId;
    }
  } else {
    initFolderId = getDefaultFolderFromFolders(folders).folderId;
  }
  const commentOrder =
    responseData.session.user && responseData.session.user.commentsOrder
      ? responseData.session.user.commentsOrder
      : 'newest';
  const params = {
    commentOrder,
  };

  return [
    setGallectionSectionType(
      section === 'gallery' ? GallectionType.GALLERY : GallectionType.COLLECTION
    ),
    setSelectedFolderId(initFolderId),
    setSelectedSubfolderId(initSubfolderId),
    setFullViewFolderIds([initFolderId]),
    setSortOrder(requestParams.mode),
    setViewType(DEFAULT_GALLECTION_VIEW_TYPE),
    getFoldersModuleInitAction(getSectionModules(responseData), {
      gallectionType,
    }),
    getFolderDeviationsInitAction(gallectionType, responseData, requestParams),
    ...getAllModulesInitActions(responseData, params),
  ];
}
